import React from 'react';

import { css } from '@emotion/react';

import Seo from '../components/seo';
import Layout from '../components/layout';
import OrderedListItem from '../components/OrderedListItem';

import { theme } from '../styles/theme';

const PrivacyPolicy = () => {
  return (
    <Layout isTermsPage={true}>
      <Seo title="Privacy Policy" />

      <div css={styles.mainContainer}>
        <article css={theme.components.row}>
          <section css={styles.termsContainer} className="theme">
            <h2 css={[theme.components.title, theme.components.titleLarge]}>
              NHS Blood Components - Terms of Use
            </h2>

            <ol className="custom-ordered-list">
              <OrderedListItem number="1">
                This agreement <strong>(“Agreement”)</strong> sets out the Terms
                of Use <strong>(“Terms of Use”)</strong> of the NHSBT/NBTC Blood
                Components Website <strong>(“Website”)</strong>. It constitutes
                a legally binding agreement by and between you (personal and
                organisational “you”)and NHS Blood and Transplant and the
                National Blood Transfusion Committee{' '}
                <strong>(“NHSBT/NBTC”/ “we”)</strong> concerning your use of the
                Website.
              </OrderedListItem>
              <OrderedListItem number="2">
                You understand these Terms of Use, agree that your use of the
                Website shall constitute acceptance of the Terms of Use and
                acknowledge our right to update the Terms of Use at any time
                without notice and to be bound by any updates.
              </OrderedListItem>
            </ol>

            <h3 css={[theme.components.title, theme.components.titleSmall]}>
              What Blood Components™ is for
            </h3>
            <ol className="custom-ordered-list">
              <OrderedListItem number="3">
                The Website comprises the mobile software application
                accompanying this Agreement, including without limitation any
                software code, scripts, interfaces, graphics, displays, text,
                documentation and other components, and any updates,
                modifications or enhancements to them.
              </OrderedListItem>

              <OrderedListItem number="4">
                The Website is intended for the sole purpose to inform users,
                within England, of the key content of the published guidelines
                on which the content is based and should be used in conjunction
                with the guidelines as listed – see the ‘About’ section.
              </OrderedListItem>

              <OrderedListItem number="5">
                The Website must not be used as a substitute for professional
                judgement or local organisational policies or procedures.
              </OrderedListItem>

              <OrderedListItem number="6">
                Users should recognise that some patients may misinterpret
                bedside smartphone use and should, therefore, explain to
                patients why they are using the smartphone in this way. You may
                tell them that the Website is not designed for the input of
                patient-identifying data and, at your discretion, inform them of
                its indicated use.
              </OrderedListItem>
            </ol>

            <h3 css={[theme.components.title, theme.components.titleSmall]}>
              Liability
            </h3>

            <ol className="custom-ordered-list">
              <OrderedListItem number="7">
                The Website, and the information contained in it, is provided to
                you "as is" with no guarantee of completeness or accuracy, and
                without warranty of any kind, express or implied, including but
                not limited to warranties of performance, merchantability and
                fitness for a particular purpose.
              </OrderedListItem>

              <OrderedListItem number="8">
                You acknowledge that Website functionality may be seriously
                affected by changes to the operating system of your device. You
                must not use the Website following an operating system change
                unless it is a version validated for use with the updated
                operating system.
              </OrderedListItem>

              <OrderedListItem number="9">
                Neither NHSBT, NBTC, developers, nor its employees or management
                shall be liable for any damages (including without limitation,
                direct, indirect, consequential or incidental damages) resulting
                from or in connection with:
              </OrderedListItem>

              <ol className="custom-ordered-list">
                <OrderedListItem number="9.1">
                  continued use of the Website where the user has not accepted
                  updates;
                </OrderedListItem>
                <OrderedListItem number="9.2">
                  any information, materials, or recommendations related to the
                  Website;
                </OrderedListItem>
                <OrderedListItem number="9.3">
                  matters beyond NHSBT’s, NBTC’s, or developers' control,
                  including without limitation the incorrectness or
                  incompleteness of input data and information provided on third
                  party websites that may be linked to, directly or indirectly,
                  by means of the App;
                </OrderedListItem>
                <OrderedListItem number="9.4">
                  any software or hardware used for electronic communications;
                </OrderedListItem>
                <OrderedListItem number="9.5">
                  any other Website on your device;
                </OrderedListItem>
                <OrderedListItem number="9.6">
                  use of the Website with any incompatible operating system;
                </OrderedListItem>
                <OrderedListItem number="9.7">
                  the disabling of the Website (for example, following updating
                  your device’s operating system);{' '}
                </OrderedListItem>
                <OrderedListItem number="9.8">
                  termination of this Agreement;
                </OrderedListItem>
                <OrderedListItem number="9.9">
                  cessation of Website function; or
                </OrderedListItem>
                <OrderedListItem number="9.10">
                  the failure or delay in the delivery of electronic data, the
                  interception or manipulation of electronic data by third
                  parties and transmission and the impact of software viruses.
                </OrderedListItem>
              </ol>

              <OrderedListItem number="10">
                Nothing in this agreement excludes or limits liability for death
                or personal injury.
              </OrderedListItem>
            </ol>

            <h3 css={[theme.components.title, theme.components.titleSmall]}>
              Intellectual Property
            </h3>

            <ol className="custom-ordered-list">
              <OrderedListItem number="11">
                Unless otherwise stated, all rights, including copyrights and
                other intellectual property rights in the App and all database
                rights in underlying databases and subsisting in information
                collected from you by NHSBT/NBTC are the property of NHSBT/NBTC.
              </OrderedListItem>
              <OrderedListItem number="12">
                Subject to data protection obligations, you may consult the App
                and the information contained therein and record App outputs
                (for example, using your device’s print screen function).
                However, any other use of the App or such information, for
                example the storage or reproduction of the App or any part of it
                in any other medium or the creation of links, hyperlinks or
                deeplinks between the App and any other medium, is prohibited
                without NHSBT’s and NBTC's explicit written permission.
              </OrderedListItem>
            </ol>

            <h3 css={[theme.components.title, theme.components.titleSmall]}>
              Privacy
            </h3>
            <ol className="custom-ordered-list">
              <OrderedListItem number="13">
                To create statistical reports about Website use, anonymous data
                generated from users, including you, are collected by means of a
                software development kit (“SDK”) placed on your phone or device
                by Firebase's web server. The SDK contains an anonymous, unique
                sequence that is only accessible by the Google Firebase web
                server. The SDK saves anonymous data about your Website use
                until your device is connected to the internet, when it sends it
                to the Firebase web server. The server collates your data with
                equivalent data from other users. No personal data is sent, and
                the anonymous data will only be accessible to NHSBT/NBTC and the
                developers of the Website, HMA Digital Marketing of 42 Sackville
                Street, Barnsley, S70 2DB.
              </OrderedListItem>
              <OrderedListItem number="14">
                The Website uses Google Firebase Analytics SDK's, Googles
                privacy policy is available at:{' '}
                <a href="http://www.google.com/policies/privacy/">
                  http://www.google.com/policies/privacy/
                </a>
                .
              </OrderedListItem>
            </ol>

            <h3 css={[theme.components.title, theme.components.titleSmall]}>
              Termination
            </h3>
            <ol className="custom-ordered-list">
              <OrderedListItem number="15">
                NHSBT/NBTC has the right to terminate this Agreement at any time
                without notice.
              </OrderedListItem>
              <OrderedListItem number="16">
                You can terminate this agreement by uninstalling the Website,
                which you may do at any time.
              </OrderedListItem>
            </ol>

            <h3 css={[theme.components.title, theme.components.titleSmall]}>
              Law and Jurisdiction
            </h3>
            <ol className="custom-ordered-list">
              <OrderedListItem number="17">
                These Terms of Use shall be governed by and construed in
                accordance with the laws of England and Wales and subject to the
                exclusive jurisdiction of the English courts, which shall settle
                all disputes arising in connection with these Terms and
                Conditions of Use.
              </OrderedListItem>
            </ol>
            <p css={styles.copyrightText}>
              NHSBT/NBTC Copyright &copy;2021. All rights reserved. Designated
              trademarks are the property of their owners.
            </p>
          </section>
        </article>
      </div>
    </Layout>
  );
};

const styles = {
  mainContainer: css({
    background: theme.colours.lightGrey,
    height: '100%',
  }),
  termsContainer: css({
    backgroundColor: '#fff',
    padding: theme.gapDouble,
    borderRadius: theme.borderRadius,
    height: '700px',
    maxHeight: '70vh',
    overflowY: 'scroll',
    marginBottom: theme.gap,
  }),
  copyrightText: css({
    fontSize: '0.9rem',
    marginTop: theme.gap,
  }),
};

export default PrivacyPolicy;
